import { useSessionUser } from "hooks/useSession";
import { useEffect } from "react";

import { setPosthogSupportIdentity } from "config/posthog-runtime";
import { isPosthogSdkEnabled } from "config";

export const PosthogSupportIdentitySync = () => {
  const { session: profile } = useSessionUser();

  useEffect(() => {
    if (!isPosthogSdkEnabled || !profile?.user_id) {
      return;
    }

    if (!profile.posthog_identity_hash) {
      if (process.env.NODE_ENV === "development") {
        console.warn(
          "[RivetAI Support] posthog_identity_hash is missing from GET /users/me. " +
            "Set POSTHOG_SECRET_API_TOKEN on the backend to your PostHog project secret API token " +
            "so logged-in support tickets are verified."
        );
      }
      return;
    }

    void setPosthogSupportIdentity(profile.user_id, profile.posthog_identity_hash);
  }, [profile?.posthog_identity_hash, profile?.user_id]);

  return null;
};
